<script>
export default {
  name: 'VcIcon',
  props: {
    dataQa: {
      type: String,
      default: 'VcIcon',
    },
    color: {
      type: String,
      default: 'black',
    },
  },
  render: function (createElement) {
    const props = {
      attrs: { ...this.$attrs, 'data-qa': this.dataQa },
      on: this.$listeners,
      style: {
        fill: this.$props.color,
        color: this.$props.color,
      },
    };

    return createElement('v-icon', props, this.$slots.default);
  },
};
</script>
